import { render } from "./InvoiceDetailPage.vue?vue&type=template&id=3c310f54&scoped=true"
import script from "./InvoiceDetailPage.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailPage.vue?vue&type=script&lang=js"

import "./InvoiceDetailPage.vue?vue&type=style&index=0&id=3c310f54&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c310f54"]])

export default __exports__